export default function initHothome() {
    const sliderElement = document.querySelector('.c-hothome__slider');

    if (!sliderElement) return;

    // Recupera os dados (imagem e cor) passados pelo PHP
    const thumbsDataRaw = sliderElement.getAttribute('data-thumbs');
    const thumbsArray = thumbsDataRaw ? JSON.parse(thumbsDataRaw) : [];

    const containerElement = sliderElement.parentElement;

    const paginationElement = containerElement.querySelector('.c-hothome__thumbs');
    const prevButton = containerElement.querySelector('.c-hothome__nav--prev');
    const nextButton = containerElement.querySelector('.c-hothome__nav--next');

    const hothomeSwiper = new Swiper(sliderElement, {
        slidesPerView: 1,
        effect: 'fade', // O fade disfarça as transições da máscara muito bem
        loop: true,

        navigation: {
            nextEl: nextButton,
            prevEl: prevButton,
        },

        pagination: {
            el: paginationElement,
            clickable: true,
            renderBullet: function (index, className) {
                const itemData = thumbsArray[index] || { image: '', color: 'var(--blue)' };

                // Injetamos a cor do fundo no style inline e a imagem na tag img
                return `
                    <button class="${className} c-hothome__thumb-btn" 
                            style="--thumb-color: ${itemData.color};" 
                            aria-label="Ir para o slide ${index + 1}">
                        <img src="${itemData.image}" alt="Navegar para produto ${index + 1}" />
                    </button>
                `;
            },
        },

        a11y: {
            prevSlideMessage: 'Slide anterior',
            nextSlideMessage: 'Próximo slide',
            paginationBulletMessage: 'Ir para o slide {{index}}',
        }
    });
}